import { render } from "./ResumeVue.vue?vue&type=template&id=0ae03157"
import script from "./ResumeVue.vue?vue&type=script&lang=js"
export * from "./ResumeVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__